<template>
  <div class="common-layout">
    <el-container class="container">
      <el-container>
        <el-header class="header">
          <NavTop />
        </el-header>
        <!-- 页面主体区域 -->
        <el-container>
          <!-- 侧边栏 -->
          <!-- <el-aside :width="isCollapse ? '64px':'200px'">
            <el-menu
              active-text-color="#E95506"
              background-color="#FFFFFF"
              text-color="#333333"
              :unique-opened="true"
              :collapse="isCollapse"
              :collapse-transition="true"
              :router="true"
              :default-active="this.$route.path"
              class="menu-class"
              @select="handleSelect"
            >
              <template v-for="(item,i) in routes">
                <el-menu-item v-if="!item.select" :key="i" :index="item.path">
                  <template #title>
                    <img
                      :src="require(`../assets/img/manage/menu/${iconsObj[item.meta.title]}_${$route.path==item.path?'a':'d'}.png`)"
                      width="16px"
                      height="16px"
                    >
                    <span @click="titleName(item.meta.title)">{{ item.meta.title }}</span>
                  </template>
                </el-menu-item>
                <el-submenu v-else :key="i" :index="item.path">
                  <template #title>
                    <img
                      :src="require(`../assets/img/manage/menu/${iconsObj[item.meta.title]}_d.png`)"
                      width="16px"
                      height="16px"
                    >
                    <router-link :to="{path:item.path}">
                      <span>{{ item.meta.title }}</span></router-link>
                  </template>
                  <el-menu-item
                    v-for="(subItem,index) in item.children"
                    v-show="!subItem.hidden"
                    :key="index"
                    :index="subItem.path"
                  ><span>{{ subItem.meta.title }}</span></el-menu-item>
                </el-submenu>

              </template>
            </el-menu>
          </el-aside> -->
          <!-- 右侧内容主体区域 -->
          <el-main>
            <div class="titleName">{{ titleNameString }}</div>
            <!-- 路由占位符 -->
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
// import AppMenu from '@/components/AppMenu.vue';
import NavTop from './manage/navTop.vue'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    NavTop
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      // 左侧菜单数据对象
      menulist: [
        //  {id:111,authName:'首页',path:'home',children:[],order:1,select: false,},
        {
          id: 110,
          authName: 'My Settings',
          path: 'produce',
          children: [{
            id: 111,
            authName: 'My Commodities',
            path: 'commodities',
            children: [],
            order: null
          },
          {
            id: 112,
            authName: 'Company profile',
            path: 'produce',
            children: [],
            order: null
          },
          {
            id: 113,
            authName: 'Account details',
            path: 'produce',
            children: [],
            order: null
          }
          ],
          order: 2,
          select: true
        }
      ],
      // 字体图标对象
      iconsObj: {
        'Shipments': 'Shipments',
        'Billing': 'Billing',
        'My Settings': 'MySettings'
      },
      // 是否折叠
      isCollapse: false,
      fatherTitle: ''
      // titleNameString:'',
    }
  },
  computed: {
    // 计算属性
    routes() {
      let list = this.$router.options.routes || []
      if (list.length > 0) {
        list = list.filter(res => {
          return res.path == '/manage'
        })
      }
      console.log('====list.children', list[0].children)
      return list[0].children
    },
    titleNameString() {
      console.log('this.$router', this.$route, this.fatherTitle, this.routes)
      return this.$route.meta.title
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    // this.getMenuList()
    console.log('菜单==', this.$router.options.routes)
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    // 获取所有的菜单数据
    // async  getMenuList () {
    //   const { data: res } = await this.$http.get('menus')
    //   if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
    //   // 成功了，进行赋值
    //   this.menulist = res.data
    //   console.log(res)
    // },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    handleSelect(key, keypath) {
      this.fatherTitle = keypath[0] || ''
      console.log(key, keypath)
    },
    titleName(name) {
      // this.titleNameString = name
    }
  }
}
</script>
<style scoped lang="scss">
	.common-layout {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 999;
		overflow: hidden;
		background: #F2F4F8;
	}

	.container {
		height: 100%;

		.titleName {
			height: 80px;
			display: flex;
			justify-content: left;
			align-items: center;
			font-size: 24px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			color: #333333;
		}

		.aside {
			background: #797979;
			width: 230px;
		}

		::v-deep .el-header {
			padding: 0;
			height: 80px !important;
		}

		.menu-class {
			height: 100%;
			text-align: left;

			img {
				margin: 0 8px;
			}

			::v-deep .el-submenu__title,
			.el-menu-item {
				height: 48px;
				line-height: 40px;
				padding: 4px 8px !important;

				&:active {
					background-color: rgba(237, 119, 56, 0.08) !important;
				}

				// &:hover{
				//       background-color: rgba(237,119,56,0.08) !important;
				// }
				a {
					color: rgb(51, 51, 51);
					text-decoration: auto;
				}
			}

			::v-deep .is-active {
				background-color: rgba(237, 119, 56, 0.08) !important;
				color: #E95506 !important;
			}

			::v-deep .el-submenu {
				.el-menu-item {
					padding-left: 39px !important;
				}
			}
		}
	}
</style>
